import type { GameModule } from '@md/engine';
import { type GameMeta, MAGNETIC_DUO_GAME_ID } from '@md/shared';
import { ABILITIES } from './abilities/index.js';
import { CHARACTERS } from './characters.js';
import { ENTITY_FACTORIES } from './entities/index.js';
import { INTERACTIONS } from './interactions.js';
import { MAGNETIC_SOLVER_PROFILE } from './solver.js';
import { TILE_LEGEND } from './tiles.js';
import { WORLDS } from './worlds.js';

/**
 * `@md/game-magnetic-duo` — le GameModule de la V1 (spec §4).
 *
 * Toute la logique SPÉCIFIQUE au jeu vit dans ce package : ni le moteur ni le
 * client ne contiennent de `if (gameId === …)`.
 *
 * PHASE 2 : duo complet (accroches, dalles mortelles), légende des six tuiles
 * magnétiques, ability « champ magnétique » (jauge, polarité, accroche,
 * dégaussage), règles d'interaction (attraction / répulsion, objets polarisés,
 * électroaimants) et fabriques d'entités.
 */
export const GAME_META: GameMeta = {
  id: MAGNETIC_DUO_GAME_ID,
  name: 'Magnetic Duo',
  description:
    "Polo et Mag, deux robots magnétiques, doivent s'échapper d'une usine abandonnée. " +
    'Aucun des deux ne peut y arriver seul.',
};

export const magneticDuo: GameModule = {
  id: MAGNETIC_DUO_GAME_ID,
  meta: GAME_META,
  characters: CHARACTERS,
  tileLegend: TILE_LEGEND,
  entityFactories: ENTITY_FACTORIES,
  abilities: ABILITIES,
  interactions: INTERACTIONS,
  worlds: WORLDS,
  solver: MAGNETIC_SOLVER_PROFILE,
};

export * from './abilities/index.js';
export * from './characters.js';
export * from './entities/index.js';
export * from './forces.js';
export * from './interactions.js';
export * from './solver.js';
export * from './tiles.js';
export * from './worlds.js';
